module.exports = __webpack_public_path__ + "img/1.22f3e424.png";